const React = require("react");

const useId = require('@reach/auto-id').useId;

function MenuOutlinedIcon(props, svgRef) {
  const id = "MenuOutlinedIcon" + '_' + useId();
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3 19h18v-1H3v1zm0-6h18v-1H3v1zm0-7v1h18V6H3z",
    id: `${id}_a`
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    xlinkHref: `#${id}_a`
  })));
}

const ForwardRef = React.forwardRef(MenuOutlinedIcon);
const MemoForwardRef = React.memo(ForwardRef);
module.exports = MemoForwardRef;